import controller from './message-view.controller';
import template from './message-view.html';
import './message-view.scss';

export default {
	template,
	bindings: {
		room: '<',
	},
	controller,
	controllerAs: 'ctrl',
};
